import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  useTheme,
} from '@mui/material';
import { Text } from '../Text/Text';
import { Copy } from '../../copy/Copy';
import { PRIVACY_LINK } from '../../constants/externalLinks';
import {
  bottomDividerSx,
  checkboxContainerSx,
  checkboxSx,
  formControlLabelSx,
  hyperlinkSx,
  topDividerSx,
} from './PrivacyCheckbox.style';

export const PrivacyCheckbox = ({ onChange }) => {
  const theme = useTheme();

  return (
    <>
      <Divider sx={topDividerSx(theme)} />

      <Box component="div" sx={checkboxContainerSx}>
        <FormControlLabel
          slotProps={formControlLabelSx(theme)}
          control={
            <Checkbox
              color="tertiary"
              sx={checkboxSx(theme)}
              onChange={onChange}
            />
          }
          label={Copy.inject('Inputs.privacyPolicy', {
            privacy: (
              <Text
                component="a"
                href={PRIVACY_LINK}
                text={Copy.generate('Links.privacyPolicy')}
                sx={hyperlinkSx(theme)}
              />
            ),
          })}
        />
      </Box>

      <Divider sx={bottomDividerSx(theme)} />
    </>
  );
};
